<template>
  <div id="homeWrap" class="text-left">
    <v-container grid-list-md fluid>
      <v-layout justify-space-between>
        <v-flex xs12>
          <!-- CREATE HOME SEARCH DATA -->
          <v-layout wrap>
            <v-flex xs12 class="dropdown-widget">
              <drop-down-widget
                :title="'CREATE HOME SEARCH'"
                :number-of-rows="
                  homeSearchData
                    ? getWithoutSavedFavorites(homeSearchData).length
                    : 0
                "
                :header-style="widgetStyles[0]"
                :is-open="widgetOptions[0].isOpen"
                @on-open="openWidgetChanged(0)"
              >
                <template v-if="agentData" v-slot:widget-content>
                  <create-home-search-widget
                    :table-data="homeSearchData"
                    :options="{ hideActions: true }"
                    @resend-invite-clicked="onSendInviteClicked($event)"
                    @client-clicked="toggleClientDetailCard($event)"
                  />
                </template>
              </drop-down-widget>
            </v-flex>

            <!-- ROUTE PLANNER DATA -->
            <v-flex xs12 class="dropdown-widget">
              <drop-down-widget
                :title="'ROUTE PLANNER'"
                :number-of-rows="
                  routePlannerData
                    ? getNotEmptyRows(routePlannerData).length
                    : 0
                "
                :header-style="widgetStyles[1]"
                :is-open="widgetOptions[1].isOpen"
                @on-open="openWidgetChanged(1)"
              >
                <template v-slot:widget-content>
                  <route-planner-widget
                    :column-names="widgetHeaders[0]"
                    :table-data="routePlannerData"
                    @client-clicked="toggleClientDetailCard"
                    @open-routes-planner-tab="openRoutePlannerTabs($event)"
                  />
                  <!-- <updated-list-component
                    :table-headers="widgetHeaders[0]"
                    :table-data="generateRoutePlannerData(widgetData[0])"
                    @client-clicked="toggleClientDetailCard($event)"
                  />-->
                </template>
              </drop-down-widget>
            </v-flex>

            <!-- REQUEST FEEDBACK -->
            <v-flex xs12 class="dropdown-widget">
              <drop-down-widget
                :title="'REQUEST FEEDBACK'"
                :number-of-rows="
                  homeSearchData
                    ? getRowsWithFeedback(homeSearchData).length
                    : 0
                "
                :header-style="widgetStyles[2]"
                :is-open="widgetOptions[2].isOpen"
                @on-open="openWidgetChanged(2)"
              >
                <!-- The component has to be wrapped in a template. -->
                <template v-slot:widget-content>
                  <request-feedback-widget
                    :table-data="homeSearchData"
                    :options="{
                      hideHeaders: false,
                      hideActions: true,
                      expand: false
                    }"
                    @client-clicked="toggleClientDetailCard"
                    @request-feedback="sendFeedbackRequest($event)"
                    @open-review-tab="openRequestFeedbackTabs($event, 1)"
                    @open-needed-tab="openRequestFeedbackTabs($event, 0)"
                  />
                </template>
              </drop-down-widget>
            </v-flex>
            <!-- MAKE OFFER -->
            <v-flex xs12 class="dropdown-widget">
              <drop-down-widget
                :title="'MAKE OFFER'"
                :number-of-rows="makeOfferData.count"
                :header-style="widgetStyles[3]"
                :is-open="widgetOptions[3].isOpen"
                @on-open="openWidgetChanged(3)"
              >
                <!-- The component has to be wrapped in a template. -->
                <template v-slot:widget-content>
                  <make-offer-widget
                    :offer-data="makeOfferData.data"
                    :column-names="makeOfferNestedHeader"
                    :make-offer-header="makeOfferHeader"
                    @client-clicked="toggleClientDetailCard"
                    @request-offer="sendRequestOffer($event)"
                  />
                </template>
              </drop-down-widget>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-slide-x-reverse-transition>
          <v-flex v-if="showClientCard" xs9 lg4>
            <!-- Sidebar -->
            <client-detail-card :client-detail-for-card="clientDetailForCard">
              <template v-slot:close-button>
                <i
                  class="material-icons corner"
                  @click="showClientCard = false"
                >close</i>
              </template>
            </client-detail-card>
          </v-flex>
        </v-slide-x-reverse-transition>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import { mapState, mapActions, mapMutations } from 'vuex'
import DropDownWidget from '../../components/home/DropDownWidget.vue'
import CreateHomeSearchWidget from '../../components/agent/dashboard/CreateHomeSearchWidget.vue'
import RequestFeedbackWidget from '../../components/agent/dashboard/RequestFeedbackWidget.vue'
import RoutePlannerWidget from '../../components/agent/dashboard/RoutePlannerWidget.vue'
import MakeOfferWidget from '../../components/agent/dashboard/MakeOfferWidget.vue'

import ClientDetailCard from '../../components/client-detail/ClientDetailCard.vue'
import {
  askClientForFeedback,
  askClientForOffer
} from '../../services/messagesService'
import {
  createFeedbackRequest,
  getPropertyById
} from '../../services/propertiesService'

import { sortNames } from '../../utils/generalUtils'
import {
  calculateFeedbackMatch,
  feedbackProvidedProperties
} from '../../utils/propertyUtils'
import colors from '../../scss/_variables.scss'
import {
  isDeclinedRoute,
  isNotScheduledType,
  isPastRoute
} from '../../utils/routeUtils'
import { onSendInviteClicked } from '../../services/invite-service'

export default {
  components: {
    DropDownWidget,
    CreateHomeSearchWidget,
    RoutePlannerWidget,
    RequestFeedbackWidget,
    MakeOfferWidget,
    ClientDetailCard
  },

  data() {
    return {
      makeOfferData: {
        count: 0,
        data: []
      },
      requestButton: {
        'background-color': colors.hwayzViolet,
        border: 'none'
      },
      showClientCard: false,
      clientDetailForCard: null,
      widgetStyles: [
        {
          'background-color': colors.hwayzBrandBlue,
          color: 'white',
          'font-weight': '500'
        },
        {
          'background-color': colors.hwayzBrandGold,
          color: 'white',
          'font-weight': '500'
        },
        {
          'background-color': colors.hwayzPurple,
          color: 'white',
          'font-weight': '500'
        },
        {
          'background-color': colors.hwayzKellyGreen,
          color: 'white',
          'font-weight': '500'
        }
      ],
      widgetHeaders: [
        [
          { text: '', value: 'name', sortable: false, align: 'center' },
          {
            text: 'Plan Route',
            value: 'planRoute',
            sortable: false,
            align: 'center'
          },
          {
            text: 'Request Showings',
            value: 'requestShowings',
            sortable: false,
            align: 'center'
          },
          {
            text: 'Send Schedule',
            value: 'sendSchedule',
            sortable: false,
            align: 'center'
          },
          {
            text: 'Scheduled',
            value: 'scheduled',
            sortable: false,
            align: 'center'
          }
        ],
        [
          { text: 'Client', value: 'name' },
          { text: 'Saved Homes', value: 'savedHomes' },
          { text: 'Toured Homes', value: 'touredHomes' },
          { text: 'Feedback', value: 'feedback' },
          { text: 'Last Active', value: 'lastActive' }
        ]
      ],
      makeOfferHeader: [
        {
          text: '',
          value: 'name',
          width: '60%',
          align: 'center',
          sortable: false
        },
        {
          text: 'Match',
          value: 'match',
          width: '25%',
          class: true,
          align: 'center',
          sortable: false
        },
        {
          text: 'Request Offer',
          value: 'send',
          align: 'center',
          sortable: false
        }
      ],
      makeOfferNestedHeader: [
        { text: '', value: 'name', sortable: false, width: '60%' },
        { text: '', value: 'match', sortable: false, width: '25%' },
        { text: '', value: 'send', sortable: false }
      ],
      widgetOptions: [
        { isOpen: -1 },
        { isOpen: -1 },
        { isOpen: -1 },
        { isOpen: -1 }
      ]
    }
  },

  computed: {
    ...mapState('agent', [
      'agentData',
      'selectedTab',
      'rhtValue',
      'agentRouteData'
    ]),

    routePlannerData() {
      // TODO: compute the arrays
      if (this.agentData && this.agentRouteData) {
        const groupedArray = _.groupBy(
          this.agentRouteData,
          route => route.clientId
        )
        let planRoutes = this.countRequested()
        let requestShowings = this.getColumnData('saved', groupedArray)
        let sendSchedules = this.getColumnData('confirmed', groupedArray)
        let scheduleds = this.getColumnData('scheduled', groupedArray)
        let clientsData = []
        if (this.agentData && this.agentData.clients) {
          this.agentData.clients.map((client, index) => {
            clientsData.push({
              ...client,
              planRoute: planRoutes[index],
              requestShowings: requestShowings[index],
              sendSchedule: sendSchedules[index],
              scheduled: scheduleds[index]
            })
          })
        }
        return sortNames(clientsData)
      }
      return []
    },

    /**
     * Retrieving number of homes for home search data
     * based on their status
     */
    homeSearchData() {
      if (this.agentData && this.agentData.clients) {
        let clientsData = this.agentData.clients.map(client => {
          const lastActive = client.lastActivity
            ? moment(client.lastActivity).format('MM-DD-YY')
            : 'N/A'
          return {
            ...client,
            lastActive
          }
        })
        return sortNames(clientsData)
      }
      return []
    }
  },

  watch: {
    async agentData() {
      this.makeOfferData = await this.getMakeOfferData()
    }
  },

  async mounted() {
    this.makeOfferData = await this.getMakeOfferData()
  },

  methods: {
    ...mapActions('agent', [
      'setSearchedClient',
      'loadRequestedHomeData',
      'setSelectedTab'
    ]),

    ...mapMutations('agent', {
      setRht: 'SET_RHT',
      setAgentData: 'SET_AGENT_DATA'
    }),
    getNotEmptyRows(clients) {
      return clients.filter(
        client =>
          client.planRoute !== 0 ||
          client.requestShowings !== 0 ||
          client.sendSchedule !== 0 ||
          client.scheduled !== 0
      )
    },
    getRowsWithFeedback(clients) {
      return clients.filter(client => client.feedback_needed > 0)
    },
    getWithoutSavedFavorites(clients) {
      return clients.filter(client => client.homes.length === 0)
    },

    openRoutePlannerTabs({ client, num }) {
      this.loadRequestedHomeData({ clientData: client, loadFavs: true })
      this.setSelectedTab(num)
      return this.$router.push({ name: 'planner' })
    },

    openRequestFeedbackTabs(client, num) {
      this.setSearchedClient(client)
      this.setRht({ loading: false, data: this.rhtValue.data })
      this.setSelectedTab(num)
      return this.$router.push({ name: 'feedback' })
    },

    generateRoutePlannerData(tableDataArray) {
      let responseData = []
      tableDataArray.forEach((item, index) => {
        let rowObject = {}
        rowObject[0] = {
          type: 'avatar',
          class: 'textLeft',
          text: item.name,
          data: { value: item, action: 'client-clicked' }
        }
        rowObject[1] = {
          type: 'clickableText',
          class: 'text-xs-center',
          text: item.planRoute,
          data: { value: item, action: 'open-plan-route' }
        }
        rowObject[2] = {
          type: 'clickableText',
          class: 'text-xs-center',
          text: item.requestShowings,
          data: { value: item, action: 'open-routes-tab' }
        }
        rowObject[3] = {
          type: 'clickableText',
          class: 'text-xs-center',
          text: item.sendSchedule,
          data: { value: item, action: 'open-routes-tab' }
        }
        rowObject[4] = {
          type: 'clickableText',
          class: 'text-xs-center',
          text: item.scheduled,
          data: { value: item, action: 'open-routes-tab' }
        }
        responseData.push(rowObject)
      })
      return responseData
    },

    countRequested() {
      let dataArray = []
      this.agentData.clients.map((client, index) => {
        dataArray[index] = 0
        client.homes.map(home => {
          if (home.requestTour === true) {
            dataArray[index] += 1
          }
        })
      })
      return dataArray
    },

    getColumnData(columnState, groupedArray) {
      let dataArray = []
      this.agentData.clients.map((client, index) => {
        dataArray[index] = 0
        Object.entries(groupedArray).forEach(([key, value]) => {
          if (key === client._id) {
            dataArray[index] = value.filter(
              item =>
                item.state === columnState &&
                !isPastRoute(item) &&
                !isDeclinedRoute(item) &&
                !isNotScheduledType(item)
            ).length
          }
        })
      })
      return dataArray
    },

    async getMakeOfferData() {
      let result = {
        count: 0,
        data: []
      }
      if (this.agentData) {
        await Promise.all(
          this.agentData.clients.map(async client => {
            let feedbackHomes = feedbackProvidedProperties(client.homes)
            feedbackHomes = feedbackHomes.filter(
              item => Math.round(this.calculateFeedbackPercent(item)) / 10 >= 8
            )
            if (feedbackHomes.length > 0) {
              feedbackHomes = await Promise.all(
                feedbackHomes.map(async home => {
                  const res = (await getPropertyById(home.propertyId)).data
                  home.propertyData = res
                  return home
                })
              )
              result.count += feedbackHomes.length
              result.data.push({
                ...{
                  id: client._id,
                  nestedTableData: feedbackHomes
                },
                ...client
              })
            }
          })
        )
      }
      return { ...result, ...{ data: sortNames(result.data) } }
    },

    calculateFeedbackPercent(home) {
      if (home.feedback) {
        return calculateFeedbackMatch(home.feedback.match)
      }
      return 'N/A'
    },

    // Modify this method to send request to agent data
    // to retrieve the clicked client data
    // At present it is displaying the searched results details
    toggleClientDetailCard(client) {
      if (!client) {
        console.log('toggleClientDetalCard(): Replace Client Data Here')
      } else {
        this.clientDetailForCard = client
        if (!this.showClientCard) {
          this.showClientCard = true
        }
      }
    },

    /**
     * Close all panels except panel by index
     * @param {String} index - index of panel which should be open
     */
    openWidgetChanged(index) {
      this.widgetOptions.forEach((item, ind) => {
        if (ind === index) {
          item.isOpen = 0
        } else {
          item.isOpen = -1
          this.showClientCard = false
        }
      })
    },

    /**
     * Sends messages with asking for feedback
     * @param {Object} data - Client data object
     */
    async sendFeedbackRequest(data) {
      const requests = data.homes.map(home => {
        return getPropertyById(home.propertyId).then(async response => {
          await askClientForFeedback({
            to: [data._id],
            address: `${response.data['Address']} ${response.data['City']} ${response.data['PostalCode']}`,
            propertyId: home.propertyId
          })
          return home._id
        })
      })
      const homes = await Promise.all(requests)
      for (const home of homes) {
        await createFeedbackRequest(data._id, home)
      }
    },

    sendRequestOffer(data) {
      const updatedProfile = { ...this.agentData }
      let propertyId = null
      updatedProfile.clients.forEach(item => {
        return item.homes.find(home => {
          if (home._id === data.homeId) {
            home.isOfferSent = true
            propertyId = home.propertyId
          }
        })
      })
      this.setAgentData(updatedProfile)

      return askClientForOffer({
        to: [data._id],
        propertyId,
        address: data.address
      })
    },

    async onSendInviteClicked(client) {
      const updatedProfile = await onSendInviteClicked(client, this.agentData)
      this.setAgentData(updatedProfile)
    }
  }
}
</script>

<style lang="sass" scoped>
#homeWrap
  h3, p
    padding-left: 15px
  .container.fluid
    padding: 5px 5px 0 5px !important

.dropdown-widget
  margin: 0 7px
  &:first-child
    margin-top: 5px

.no-padding
  padding: 0 !important

.button-close
  position: absolute
  top: 5px
  right: 10px
  cursor: pointer

.button-close-icon
  color: #a1a1a1 !important
  font-size: 15px

.theme--light.v-table tbody tr:not(:last-child)
  border-bottom: 1px solid rgba(0,0,0,.12)
.text-xs-center
  text-align: center !important
.custom-table-class .v-table thead tr th
  font-weight: 500 !important
  color: $hwayzBlack
@media only screen and (min-width: 960px)
  .flex.lg4
    flex-basis: 40% !important
    max-width: 40% !important
</style>
